import React from 'react';

const ArrowNext = ({...props}) => {
    return (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" width="11" height="17" viewBox="0 0 11 17" fill="none">
            <path d="M2.01758 1.79297L8.70603 8.41309L2.01758 15.0332" stroke="#6E7074" strokeWidth="2" strokeLinecap="square" />
        </svg>
    )
}

export default ArrowNext;